import React from "react";
import { formatCurrency } from "../../utils/currencyUtils";

const PayrollSummary = ({ tutorSummary, isLocked, isPaid, payLoading, onTogglePaid, onDownloadPdf, pdfDownloading, showPdfButton }) => {
  const styles = {
    card: {
      background: "white",
      borderRadius: "0.5rem",
      boxShadow: "0 1px 3px 0 rgba(0,0,0,0.1)",
      padding: "1.5rem",
      border: "1px solid #e2e8f0",
      marginBottom: "1.5rem",
    },
    cardTitle: { fontSize: "1.25rem", fontWeight: "600", color: "#001272", margin: "0 0 1rem 0" },
    grid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "0.75rem" },
    stat: {
      backgroundColor: "#f8fafc",
      padding: "1rem",
      borderRadius: "0.375rem",
      border: "1px solid #e2e8f0",
      display: "flex",
      flexDirection: "column",
      gap: "0.25rem",
    },
    label: { fontSize: "0.75rem", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" },
    value: { fontSize: "1.1rem", fontWeight: "600", color: "#001272" },
  };

  return (
    <div style={styles.card}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: isLocked ? "0.5rem" : "1rem" }}>
        <h2 style={{ ...styles.cardTitle, margin: 0 }}>Payroll Summary</h2>
        {isLocked && (
          <span style={{
            fontSize: "0.78rem",
            fontWeight: "600",
            padding: "0.25rem 0.65rem",
            borderRadius: "9999px",
            backgroundColor: isPaid ? "#dcfce7" : "#fef9c3",
            color: isPaid ? "#166534" : "#854d0e",
          }}>
            {isPaid ? "✓ Paid" : "Unpaid"}
          </span>
        )}
      </div>
      {isLocked && (
        <div style={{ display: "flex", gap: "0.5rem", marginBottom: "1rem", flexWrap: "wrap" }}>
          <button
            disabled={payLoading}
            onClick={onTogglePaid}
            style={{
              border: "none",
              borderRadius: "0.375rem",
              padding: "0.4rem 0.9rem",
              fontSize: "0.8rem",
              fontWeight: "600",
              cursor: payLoading ? "not-allowed" : "pointer",
              opacity: payLoading ? 0.6 : 1,
              backgroundColor: isPaid ? "#f1f5f9" : "#16a34a",
              color: isPaid ? "#374151" : "white",
            }}
          >
            {payLoading ? "…" : isPaid ? "Unmark as Paid" : "Mark as Paid"}
          </button>
          {showPdfButton && (
            <button
              onClick={onDownloadPdf}
              disabled={pdfDownloading}
              style={{
                border: "none",
                borderRadius: "0.375rem",
                padding: "0.4rem 0.9rem",
                fontSize: "0.8rem",
                fontWeight: "600",
                cursor: pdfDownloading ? "not-allowed" : "pointer",
                backgroundColor: pdfDownloading ? "#e2e8f0" : "#001272",
                color: pdfDownloading ? "#64748b" : "white",
                whiteSpace: "nowrap",
              }}
            >
              {pdfDownloading ? "Preparing…" : "↓ Download PDF"}
            </button>
          )}
        </div>
      )}

      <div style={styles.grid}>
        <div style={styles.stat}>
          <div style={styles.label}>Gross Earnings</div>
          <div style={{ ...styles.value, color: "#059669" }}>
            {formatCurrency(tutorSummary?.gross)}
          </div>
        </div>
        <div style={styles.stat}>
          <div style={styles.label}>Total Deductions</div>
          <div style={{ ...styles.value, color: "#dc2626" }}>
            {formatCurrency(tutorSummary?.deductions)}
          </div>
        </div>
        {tutorSummary?.adjustments != null && parseFloat(tutorSummary.adjustments) !== 0 && (
          <div style={{ ...styles.stat, backgroundColor: "#faf5ff", borderColor: "#e9d5ff" }}>
            <div style={styles.label}>Adjustments</div>
            <div style={{ ...styles.value, color: parseFloat(tutorSummary.adjustments) >= 0 ? "#7e22ce" : "#dc2626" }}>
              {formatCurrency(tutorSummary.adjustments)}
            </div>
          </div>
        )}
        <div style={{ ...styles.stat, backgroundColor: "#f0f9ff", borderColor: "#bae6fd", gridColumn: "span 1" }}>
          <div style={styles.label}>Net Pay</div>
          <div style={{ ...styles.value, color: "#0369a1", fontSize: "1.4rem" }}>
            {formatCurrency(tutorSummary?.net)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayrollSummary;
